import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { messages as enMessages } from './locales/en/messages';
import { messages as frMessages } from './locales/fr/messages';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { DEFAULT_LOCALE } from './utils/constants';

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

i18n.load({
    en: enMessages,
    fr: frMessages,
});
i18n.activate(DEFAULT_LOCALE);

/**
 * We do a dynamic import of just the catalog that we need
 * @param locale any locale string
 */
export async function activateLocale(locale: string) {
    // const { messages } = await import(`./locales/${locale}/messages`);
    // i18n.load(locale, messages);
    i18n.activate(locale);
}
(window as any).activateLocale = activateLocale;

root.render(
    <I18nProvider i18n={i18n}>
        <App />
    </I18nProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
